'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(require('vue'));
var Component = require('vue-class-component');
var Component__default = _interopDefault(Component);

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
exports.MuggleMixin = class extends Vue {
  get muggle() {
    const { shadowRoot } = this.$root.$options;
    return !shadowRoot || shadowRoot instanceof HTMLHeadElement;
  }
};
exports.MuggleMixin = __decorateClass([
  Component__default
], exports.MuggleMixin);
